import styled from "styled-components";

export const Container = styled.div`
  .content {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    margin-left: 10px;
    gap: 10px;
  }
`;

export const EnableVariableChargeContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
`;

export const SectionTitle = styled.h4`
  font-weight: bold;
  margin-bottom: 10px;
`;

export const Title = styled.h4`
  margin-bottom: 0px;
`;

export const infoCircleStyle = {
  fontSize: 18,
  color: "#2B96FC",
};
